import { X } from 'lucide-react';
import { Button } from '../ui';

interface DiffModalProps {
  isOpen: boolean;
  diff: string | null;
  onClose: () => void;
}

export function DiffModal({ isOpen, diff, onClose }: DiffModalProps) {
  if (!isOpen || !diff) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={onClose}>
      <div className="bg-white dark:bg-dark-elevated rounded-lg shadow-xl max-w-3xl w-full mx-4 max-h-[80vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200 dark:border-dark-border">
          <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100">Edit Diff</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="flex-1 overflow-auto p-4">
          <pre className="text-sm font-mono whitespace-pre-wrap break-words">
            {diff.split('\n').map((line, i) => {
              let className = 'text-gray-700 dark:text-gray-300';
              if (line.startsWith('+') && !line.startsWith('+++')) {
                className = 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300';
              } else if (line.startsWith('-') && !line.startsWith('---')) {
                className = 'bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-300';
              } else if (line.startsWith('@@')) {
                className = 'text-purple-600 dark:text-purple-400';
              }
              // Decode HTML entities for display
              const textarea = document.createElement('textarea');
              textarea.innerHTML = line || ' ';
              const decodedLine = textarea.value;
              return <div key={i} className={className}>{decodedLine}</div>;
            })}
          </pre>
        </div>
        <div className="flex justify-end px-4 py-3 border-t border-gray-200 dark:border-dark-border">
          <Button variant="secondary" size="sm" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </div>
  );
}
